<template>
  <div class="content">
    <base-header :choose-index="-1" ref="header_content"></base-header>
    <div class="middle_content">
      <div class="middle_content-input">
        <div class="middle_content-input-product">
          <swiper :options="swiperOption" class="middle_content-input-product-swiper">
            <swiper-slide v-for="(item,index) in website_product.product_imgs" :key="index">
              <div
                class="middle_content-input-product-pic"
                v-bgImg="utils.getQiniuWidthUrl(item, 792, 2, 'webp')"
              ></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <div class="middle_content-input-product-right-title">{{website_product.product_model}}</div>
          <div class="middle_content-input-product-right-desc">{{website_product.product_slogan}}</div>
          <div class="middle_content-input-product-right-gray"></div>
          <div class="middle_content-input-product-right">
            <!-- <div class="middle_content-input-product-right-color">
              <div
                class="middle_content-input-product-right-color-item"
                v-for="(item, index) in website_product.product_colors"
                :key="index"
                :style="{background: item ,boxShadow: '-1px -1px 6px 0px' + item + 'inset'}"
              ></div>
            </div>-->
            <a :href="website_product.product_link" target="_blank">
              <div
                class="middle_content-input-product-right-pic"
                v-bgImg="require('@@/assets/img/westa/product/立即购买.png')"
              ></div>
            </a>
            <div class="middle_content-input-product-right-desc1">产品参数：</div>
            <div class="middle_content-input-product-right-line"></div>
            <div
              class="middle_content-input-product-right-desc"
              v-for="(item, index) in website_product.product_params"
              :key="index"
            >{{item.title}}： {{item.value}}</div>
          </div>
        </div>
      </div>
      <div class="middle_content-content">
        <HtmlContent
          :html_content="website_product.product_content"
          v-if="website_product.product_content"
        ></HtmlContent>
      </div>
      <div class="middle_content-tab">
        <div class="middle_content-tab-list">
          <div
            class="middle_content-tab-item"
            :class="{'middle_content-tab-item-active': chooseTab === '同类推荐'}"
            @click="chooseTab = '同类推荐'"
          >同类推荐</div>
          <!-- <div
            class="middle_content-tab-item"
            :class="{'middle_content-tab-item-active': chooseTab === '组合搭配'}"
            @click="chooseTab = '组合搭配'"
          >组合搭配</div>-->
        </div>
      </div>
      <div class="middle_content-list" v-show="chooseTab === '同类推荐'">
        <a
          :href="'/mobile/detail?id='+item.product_id"
          target="_blank"
          class="middle_content-list-item"
          v-for="item in recommend_website_products"
          :key="item.product_id"
        >
          <div
            class="middle_content-list-item-tag"
            v-bgImg="require('@@/assets/img/westa/product/明星产品.png')"
            v-if="item.product_is_hot === 'true'"
          ></div>
          <div
            class="middle_content-list-item-pic"
            :class="{'middle_content-list-item-pic-margin': item.product_is_hot === 'false'}"
            v-bgImg="utils.getQiniuWidthUrl(getCover(item.product_imgs), 388, 3, 'png')"
          ></div>
          <div class="middle_content-list-item-title">{{item.product_model}}</div>
          <div class="middle_content-list-item-desc">{{item.product_slogan}}</div>
        </a>
        <div style="color:#f2f2f2;">sd</div>
      </div>
      <!-- <div class="middle_content-list" v-show="chooseTab === '组合搭配'">
        <div
          class="middle_content-list-item"
          v-bgImg="require('@@/assets/img/westa/product/产品3.png')"
        ></div>
        <div
          class="middle_content-list-item"
          v-bgImg="require('@@/assets/img/westa/product/产品3.png')"
        ></div>
        <div
          class="middle_content-list-item"
          v-bgImg="require('@@/assets/img/westa/product/产品3.png')"
        ></div>
      </div>-->
    </div>
    <base-footer></base-footer>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
import HtmlContent from "@/common/html_content/html_content";
export default {
  data() {
    return {
      chooseTab: "同类推荐",
      id: "",
      website_product: {},
      recommend_website_products: [],
      swiperOption: {
        // direction: "vertical",
        // spaceBetween: 30,
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        slidesPerView: 1,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`;
          }
        }
      },
      img_length: 0
    };
  },
  components: {
    BaseHeader,
    BaseFooter,
    HtmlContent
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      let id = this.$route.query.id;
      this.id = id;
      this.getInfo();
    }
  },
  created() {
    let id = this.$route.query.id;
    this.id = id;
    this.getInfo();
  },
  mounted() {},
  methods: {
    getInfo() {
      let params = {
        product_id: this.id
      };
      this.req
        .get(
          url_api_web_websiteProduct_getWebisteProductById,
          this.qs.stringify(params)
        )
        .then(result => {
          this.website_product = result.website_product;
          this.recommend_website_products = result.recommend_website_products;
          this.website_product.product_colors = this.website_product.product_colors.split(
            ","
          );
          this.website_product.product_imgs = this.website_product.product_imgs.split(
            ","
          );
          let len = this.website_product.product_imgs.length;
          console.log(len);
          if (len < 2) {
            this.website_product.product_imgs = [];
            this.img_length = 0;
          } else {
            this.website_product.product_imgs.shift();
            console.log(this.website_product.product_imgs);
            this.img_length = this.website_product.product_imgs.length;
          }
          this.website_product.product_params = JSON.parse(
            result.website_product.product_params
          );
        })
        .catch(error => {});
    },
    getCover(str) {
      return str.split(",")[0];
    }
  }
};
</script>


<style lang="less" scoped>
.middle_content {
  padding-top: 88px;
  background: #f2f2f2;
  &-input {
    width: 100%;
    // height: 800px;
    background: #fff;
    &-product {
      width: 750px;
      height: 100%;
      margin: 0 auto;
      // display: flex;
      // padding-top: 50px;
      // box-sizing: border-box;
      &-swiper {
        margin: 0;
      }
      // align-items: center;
      &-pic {
        width: 750px;
        height: 750px;
      }
      &-right {
        // margin-left: 64px;
        // height: 680px;
        // overflow-y: scroll;
        // -ms-overflow-style: none;
        // overflow: -moz-scrollbars-none;
        // &::-webkit-scrollbar {
        //   width: 0 !important;
        // }
        &-title {
          font-size: 36px;
          color: #333;
          font-weight: bold;
          margin-top: 40px;
          margin-left: 30px;
        }
        &-desc {
          font-size: 28px;
          color: #666;
          margin-top: 24px;
          margin-left: 30px;
          margin-bottom: 30px;
        }
        &-gray {
          width: 100%;
          height: 20px;
          background: #f2f2f2;
        }
        &-color {
          display: flex;
          margin-top: 32px;
          margin-bottom: 36px;
          &-item {
            width: 20px;
            height: 20px;
            border-radius: 100%;
            // background: radial-gradient(circle at 8px 8px, #5cabff, #000);
            margin-right: 20px;
            background-blend-mode: multiply;
          }
        }
        &-pic {
          width: 242px;
          height: 124px;
          position: fixed;
          bottom: 36px;
          left: 0;
        }
        &-desc1 {
          font-size: 36px;
          color: #333;
          font-weight: bold;
          margin-top: 40px;
          margin-left: 30px;
          margin-bottom: 28px;
        }
        &-line {
          width: 690px;
          height: 1px;
          background: #ebebeb;
          margin: 0 auto;
        }
      }
    }
  }
  &-content {
    width: 750px;
    margin: 20px auto;
  }
  &-tab {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 48px;
    &-list {
      display: flex;
      align-items: center;
      width: 750px;
      margin: 0 auto;
      font-size: 36px;
      color: #999;
      font-weight: bold;
    }
    &-item {
      margin-right: 42px;
      margin-left: 30px;
      &-active {
        color: #333;
      }
    }
  }
  &-list {
    width: 750px;
    margin: 0 auto;
    display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    padding-bottom: 88px;
    background: #f2f2f2;
    // padding-left: 10px;
    // padding-right: 10px;
    box-sizing: border-box;
    overflow-x: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      height: 0 !important;
    }
    &-item {
      width: 356px;
      height: 484px;
      // margin-right: 18px;
      margin-bottom: 18px;
      background: #fff;
      text-align: center;
      border-radius: 12px;
      margin-left: 18px;
      &-tag {
        width: 138px;
        height: 48px;
        margin-top: 20px;
        margin-left: 20px;
      }
      &-pic {
        width: 356px;
        height: 260px;
        &-margin {
          margin-top: 64px;
        }
      }

      &-title {
        font-size: 30px;
        color: #333;
        margin-top: 40px;
      }
      &-desc {
        font-size: 18px;
        color: #666;
        margin-top: 16px;
      }
    }
  }
}
</style>
<style>
.swiper-pagination-bullet-custom {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: gray;
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
  margin-right: 6px;
}
.swiper-pagination-bullet-custom.swiper-pagination-bullet-active {
  width: 10px;
  height: 10px;
  background: rgba(0, 0, 0, 0.8);
}
</style>

